import {
  forwardRef,
  ForwardRefRenderFunction,
  InputHTMLAttributes,
} from "react";
import { ErrorMessage } from "../ErrorMessage";

import { Container, Content } from "./styles";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  icon?: JSX.Element;
  cbIcon?: any;
  error?: string;
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, Props> = (
  { placeholder, type, error, icon, cbIcon, value, ...rest },
  ref
) => {
  return (
    <Container>
      <Content hasIcon={!(icon == null)}>
        <input {...rest} placeholder={placeholder} type={type} ref={ref} />
        <button onClick={cbIcon} type="button">
          {icon}
        </button>
      </Content>
      {error && <ErrorMessage erro={error} />}
    </Container>
  );
};

export const Input = forwardRef(InputBase);
